import type { ReplacementsType } from '@/helper/replacements';
import type { ComponentTeaserStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';

import TeaserClient from './TeaserClient';

export interface TeaserPromotionTracking {
  isPersonalized: boolean;
}

export type TeaserVariant = 'search';

interface TeaserProps {
  blok: ComponentTeaserStoryblok;
  promotionTracking?: TeaserPromotionTracking;
  replace?: ReplacementsType;
  variant?: TeaserVariant;
}

const Teaser: React.FC<TeaserProps> = ({ blok, promotionTracking, replace, variant }) => {
  return (
    <div id={blok.anchor || undefined} {...storyblokEditable(blok)}>
      <TeaserClient blok={blok} promotionTracking={promotionTracking} replace={replace} variant={variant} />
    </div>
  );
};

export default Teaser;
